import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import {
  IbanInvoicePaymentAddCommand,
  IbanInvoicePaymentApi,
  IbanInvoicePaymentCreateResponseDto,
} from "api";

const ibanInvoicePaymentApi = new IbanInvoicePaymentApi();

export interface IbanInvoicePaymentState {
  paymentUrl?: string;
  isPaymentUrlModalOpen: boolean;
}

const initialState: IbanInvoicePaymentState = {
  paymentUrl: "",
  isPaymentUrlModalOpen: false,
};

export const createIbanInvoicePayment = createAsyncThunk<
  IbanInvoicePaymentCreateResponseDto,
  {
    body: IbanInvoicePaymentAddCommand;
  }
>("ibanInvoicePayment/create", async ({ body }) => {
  const { data } = await ibanInvoicePaymentApi.apiIbanInvoicePaymentPost(body);

  return data;
});

const ibanInvoicePaymentSlice = createSlice({
  name: "ibanInvoicePayment",
  initialState,
  reducers: {
    setPaymentUrl(state, action) {
      state.paymentUrl = action.payload;
    },
    setIsPaymentUrlModalOpen(state, action) {
      state.isPaymentUrlModalOpen = action.payload;
    },
  },
  extraReducers: (builder) => {
    builder.addCase(createIbanInvoicePayment.fulfilled, (state, action) => {
      state.paymentUrl = action.payload.ibanPaymentUrl;
    });
  },
});

export const { setPaymentUrl, setIsPaymentUrlModalOpen } =
  ibanInvoicePaymentSlice.actions;
export default ibanInvoicePaymentSlice.reducer;
